import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Hero from '../modules/Hero/Hero';
import CaseStudiesQuote from './CaseStudiesQuote';
import RegisterBlock from '../modules/RegisterBlock';
import CaseStudiesPartnerParagraph from './CaseStudiesPartnerParagraph';
import globals from '../globals';
import HelmetDefault from '../layout/HelmetDefault';

const CaseStudiesBusiness = () => {
  const { type } = useParams();
  const [data, setData] = useState();
  const [readMore, setReadMore] = useState(false);
  const [dataReceived, setDataReceived] = useState(false);
  const containerRef = useRef();
  const whyManagedRef = useRef();

  useEffect(() => {
    if (type) {
      fetch(`/api/case-studies/${type}`)
        .then(result => result.json())
        .then((result) => {
          setData(result);
          setDataReceived(true);
          globals.animatePageIn(containerRef.current);
          globals.genericAnimation(whyManagedRef.current);
        })
        .catch((error) => {
          console.log(error);
          setDataReceived(false);
      })
    }
  }, [type]);

  let partnerTextBlock;
  if (dataReceived) {
    partnerTextBlock = data.partnerCopy.content.map((paragraph, key) => {
      return (
        <p key={key} dangerouslySetInnerHTML={{__html: paragraph}} />
      )
    })
  }

  return (
    <div ref={containerRef} style={{ opacity: 0 }}>
      <HelmetDefault {...data}/>
      {dataReceived &&
        <div className={`${type} case-studies`}>
          <Hero title={data.title} subTitle={data.subTitle} leadCopy={data.leadCopy} dataReceived={dataReceived} type={type} />
          {data.quote && <CaseStudiesQuote quote={data.quote.phrase} quote_info={data.quote.info} />}
          <CaseStudiesPartnerParagraph article={data.description} />
          <div className="partner-copy row">
              <div className={`read-more-txt read-more-partner ${readMore ? 'expanded' : 'collapsed'} col-md-8 col-md-offset-1 col-xs-12`} ref={whyManagedRef}>
                {partnerTextBlock}
                <div className="mask"></div>
              </div>
              <div className="mobile-read-more-btn text-center">
                <button className={`${!readMore ? 'read-more-btn' : 'read-more-btn reverse'}`} onClick={() => setReadMore(!readMore)}>{!readMore ? 'Read more' : 'Read less'}</button>
              </div>
          </div>
          <div className="bottom-wave-darkgreen" />
          <RegisterBlock />
        </div>
      }
    </div>
  )
}


export default CaseStudiesBusiness


// WEBPACK FOOTER //
// ./resources/assets/js/caseStudies/CaseStudiesBusiness.js